import Icon from 'components/base/Icon';
import styled from 'styled-components';

const StyledAutoMonitoredIndicator = styled.div`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  & svg#CheckCircleOutlineIcon {
    margin-right: 0.3rem;
  }
`;

const AutoMonitoredIndicator = () => {
  return (
    <StyledAutoMonitoredIndicator>
      <Icon name='CheckCircleOutlineIcon' color='malachite' />
      Auto monitored
    </StyledAutoMonitoredIndicator>
  );
};

export default AutoMonitoredIndicator;
